<template>
  <v-container fluid class="pa-6">
    <v-row justify="center">
      <v-col cols="12" md="8" lg="6">
        <!-- Profile Header -->
        <v-card class="mb-6" elevation="2">
          <v-card-title class="d-flex align-center pa-6">
            <v-avatar size="64" color="primary" class="me-4">
              <v-icon size="32" color="white">mdi-account</v-icon>
            </v-avatar>
            <div>
              <h2 class="text-h5 mb-1">الملف الشخصي</h2>
              <p class="text-body-2 text-grey ma-0">عرض وإدارة معلوماتك الشخصية</p>
            </div>
          </v-card-title>
        </v-card>

        <!-- Profile Information -->
        <v-row>
          <!-- Basic Information -->
          <v-col cols="12" lg="12">
            <v-card elevation="2" :loading="loading">
              <v-card-title class="d-flex justify-space-between align-center">
                <span>المعلومات الأساسية</span>
                <v-btn
                  color="primary"
                  variant="outlined"
                  prepend-icon="mdi-refresh"
                  @click="loadProfile"
                  :loading="loading"
                >
                  تحديث
                </v-btn>
              </v-card-title>
              
              <v-divider></v-divider>
              
              <v-card-text class="pa-6">
                <v-row v-if="profile">
                  <!-- Name -->
                  <v-col cols="12" sm="4">
                    <div class="profile-field">
                      <v-icon color="primary" class="me-3">mdi-account-outline</v-icon>
                      <div>
                        <div class="field-label">الاسم</div>
                        <div class="field-value">{{ profile.name || 'غير محدد' }}</div>
                      </div>
                    </div>
                  </v-col>
                  
                  <!-- Email -->
                  <v-col cols="12" sm="4">
                    <div class="profile-field">
                      <v-icon color="primary" class="me-3">mdi-email-outline</v-icon>
                      <div>
                        <div class="field-label">البريد الإلكتروني</div>
                        <div class="field-value">{{ profile.email || 'غير محدد' }}</div>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="12" lg="4">
         
                <div v-if="profile && profile.stamp_url" class="text-center">
                  <div class="stamp-container">
                    <img 
                      :src="profile.stamp_url" 
                      alt="ختم المستخدم"
                      class="user-stamp"
                      @error="handleStampError"
                    />
                  </div>
                  <p class="text-caption text-grey mt-3"> توقيعة الموظف </p>
                </div>
                <div v-else-if="profile && !profile.stamp_url" class="text-center py-8">
                  <v-icon size="64" color="grey-lighten-1" class="mb-4">mdi-stamp</v-icon>
                  <p class="text-body-2 text-grey">لا يوجد ختم محدد</p>
                </div>
                <div v-else-if="loading" class="text-center py-8">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    size="32"
                  ></v-progress-circular>
                  <p class="text-caption mt-2">جاري التحميل...</p>
                </div>
             
          </v-col>
                  
                  <!-- Phone -->
                  <v-col cols="12" sm="4" v-if="profile.phone">
                    <div class="profile-field">
                      <v-icon color="primary" class="me-3">mdi-phone-outline</v-icon>
                      <div>
                        <div class="field-label">رقم الهاتف</div>
                        <div class="field-value">{{ profile.phone }}</div>
                      </div>
                    </div>
                  </v-col>
                  
                  <!-- Employee ID -->
                  <v-col cols="12" sm="4" v-if="profile.employee_id">
                    <div class="profile-field">
                      <v-icon color="primary" class="me-3">mdi-badge-account-outline</v-icon>
                      <div>
                        <div class="field-label">رقم الموظف</div>
                        <div class="field-value">{{ profile.employee_id }}</div>
                      </div>
                    </div>
                  </v-col>
                  
                  <!-- Status -->
                  <v-col cols="12" sm="4">
                    <div class="profile-field">
                      <v-icon color="primary" class="me-3">mdi-account-check-outline</v-icon>
                      <div>
                        <div class="field-label">الحالة</div>
                        <div class="field-value">
                          <v-chip 
                            :color="profile.active ? 'success' : 'error'" 
                            variant="tonal" 
                            size="small"
                          >
                            <v-icon start size="small">
                              {{ profile.active ? 'mdi-check' : 'mdi-close' }}
                            </v-icon>
                            {{ profile.active ? 'نشط' : 'غير نشط' }}
                          </v-chip>
                        </div>
                      </div>
                    </div>
                  </v-col>
                  
                  <v-col cols="12" sm="4" v-if="profile.created_at">
                    <div class="profile-field">
                      <v-icon color="primary" class="me-3">mdi-calendar-plus-outline</v-icon>
                      <div>
                        <div class="field-label">الرقم الوطني</div>
                        <div class="field-value">{{ profile.nid }}</div>
                      </div>
                    </div>
                  </v-col>   <v-col cols="12" sm="4" v-if="profile.created_at">
                    <div class="profile-field">
                      <v-icon color="primary" class="me-3">mdi-calendar-plus-outline</v-icon>
                      <div>
                        <div class="field-label">الرقم الوظيفي </div>
                        <div class="field-value">{{profile.emp_no }}</div>
                      </div>
                    </div>
                  </v-col><!-- Created Date -->





                  <v-col cols="12" sm="4" v-if="profile.created_at">
                    <div class="profile-field">
                      <v-icon color="primary" class="me-3">mdi-calendar-plus-outline</v-icon>
                      <div>
                        <div class="field-label">تاريخ الإنشاء</div>
                        <div class="field-value">{{ formatDate(profile.created_at) }}</div>
                      </div>
                    </div>
                  </v-col>
                  
                  <!-- Last Updated -->
                  <v-col cols="12" sm="4" v-if="profile.updated_at">
                    <div class="profile-field">
                      <v-icon color="primary" class="me-3">mdi-calendar-edit-outline</v-icon>
                      <div>
                        <div class="field-label">آخر تحديث</div>
                        <div class="field-value">{{ formatDate(profile.updated_at) }}</div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
                
                <!-- Loading State -->
                <div v-if="loading && !profile" class="text-center py-8">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    size="64"
                  ></v-progress-circular>
                  <p class="text-body-1 mt-4">جاري تحميل بيانات الملف الشخصي...</p>
                </div>
                
                <!-- Error State -->
                <div v-if="error && !profile" class="text-center py-8">
                  <v-icon size="64" color="error" class="mb-4">mdi-alert-circle-outline</v-icon>
                  <h3 class="text-h6 mb-2">فشل في تحميل البيانات</h3>
                  <p class="text-body-2 text-grey mb-4">{{ error }}</p>
                  <v-btn
                    color="primary"
                    variant="outlined"
                    @click="loadProfile"
                  >
                    إعادة المحاولة
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          
          <!-- User Stamp -->
       
        </v-row>
        
        <!-- User Departments -->
        <v-card elevation="2" class="mt-6" v-if="profile && profile.departments && profile.departments.length > 0">
          <v-card-title class="d-flex align-center">
            <v-icon color="primary" class="me-3">mdi-office-building</v-icon>
            الأقسام والوظائف
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-6">
            <v-row>
              <v-col 
                v-for="(department, index) in profile.departments" 
                :key="index"
                cols="12" 
                sm="6" 
                md="4"
              >
                <v-card variant="outlined" class="department-card">
                  <v-card-text class="pa-4">
                    <div class="d-flex align-center mb-3">
                      <v-icon color="primary" class="me-2">mdi-office-building-outline</v-icon>
                      <span class="text-subtitle-1 font-weight-medium">القسم</span>
                    </div>
                    
                    <div class="mb-3">
                      <div class="field-label">معرف القسم</div>
                      <div class="field-value">{{ department.department_id || 'غير محدد' }}</div>
                    </div>
                    
                    <div class="mb-3">
                      <div class="field-label">معرف الوظيفة</div>
                      <div class="field-value">{{ department.department_job_id || 'غير محدد' }}</div>
                    </div>
                    
                    <div v-if="department.is_primary" class="mt-3">
                      <v-chip color="primary" variant="tonal" size="small">
                        <v-icon start size="small">mdi-star</v-icon>
                        القسم الأساسي
                      </v-chip>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        
        <!-- No Departments State -->
        <v-card elevation="2" class="mt-6" v-else-if="profile && (!profile.departments || profile.departments.length === 0)">
          <v-card-title class="d-flex align-center">
            <v-icon color="primary" class="me-3">mdi-office-building</v-icon>
            الأقسام والوظائف
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-6">
            <div class="text-center py-8">
              <v-icon size="64" color="grey-lighten-1" class="mb-4">mdi-office-building-outline</v-icon>
              <p class="text-body-2 text-grey">لا توجد أقسام مخصصة لهذا المستخدم</p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { showErrorAlert } from '@/utils/alertUtils'

export default {
  name: 'ProfileView',
  data() {
    return {
      profile: null,
      loading: false,
      error: null
    }
  },
  async mounted() {
    await this.loadProfile()
  },
  methods: {
    async loadProfile() {
      this.loading = true
      this.error = null
      
      try {
        // Import api client dynamically
        const { default: apiClient } = await import('@/services/api')
        
        const response = await apiClient.get('/admin/profile')
        //console.log('Profile API response:', response)
        
        // Handle different response structures
        if (response.data && response.data.data) {
          this.profile = response.data.data
        } else if (response.data) {
          this.profile = response.data
        } else {
          this.profile = response
        }
        
        //console.log('Profile data:', this.profile)
        
      } catch (error) {
        console.error('Error loading profile:', error)
        this.error = error.response?.data?.message || error.message || 'حدث خطأ أثناء تحميل بيانات الملف الشخصي'
        showErrorAlert(this.$store, error, 'فشل في تحميل الملف الشخصي')
      } finally {
        this.loading = false
      }
    },
    
    formatDate(date) {
      if (!date) return 'غير محدد'
      return new Date(date).toLocaleDateString('ar-LY', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    
    handleStampError(event) {
      event.target.src = '/assets/images/default-stamp.png'; // Fallback to a default image
    }
  }
}
</script>

<style scoped>
.profile-field {
  display: flex;
  align-items: flex-start;
  padding: 12px 0;
}

.field-label {
  font-weight: 600;
  color: #666;
  font-size: 14px;
  margin-bottom: 4px;
}

.field-value {
  font-size: 16px;
  color: #333;
  word-break: break-word;
}

.v-card {
  border-radius: 12px;
}

.v-card-title {
  font-weight: 600;
}

/* Stamp styles */
.stamp-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 2px dashed #e0e0e0;
}

.user-stamp {
  max-width: 100%;
  max-height: 200px;
  width: auto;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Department card styles */
.department-card {
  height: 100%;
  transition: all 0.3s ease;
  border: 1px solid #e0e0e0;
}

.department-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .profile-field {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .profile-field .v-icon {
    margin-bottom: 8px;
    margin-right: 0;
  }
}
</style> 